import { render, staticRenderFns } from "./PontoNearbyU.vue?vue&type=template&id=6f24332e&scoped=true&v=4"
import script from "./PontoNearbyU.vue?vue&type=script&lang=js&v=4"
export * from "./PontoNearbyU.vue?vue&type=script&lang=js&v=4"
import style0 from "./PontoNearbyU.vue?vue&type=style&index=0&id=6f24332e&scoped=true&lang=css&v=4"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f24332e",
  null
  
)

export default component.exports